import { useState, useEffect, useContext } from "react";
import { Row, Col, Breadcrumb, Button, Input, Image, Form, Modal, } from "antd";
import useRequest from "../../hooks/useRequest";
import { AuthContext } from "../../context/AuthContext";
import apiPath from "../../constants/apiPath";
import { ShowToast, Severty } from "../../helper/toast";
import { NavLink, Link, useNavigate } from "react-router-dom";
import notfound from "../../assets/images/not_found.png";
import useNotification from "../../hooks/useNotification";
import lang from "../../helper/lang";
import SingleImageUpload from "../SingleImageUpload";
import defaultLogo from "../../assets/images/default-logo.png";
import LogonewImg from "../../assets/images/Clip_path_logo.svg";


const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

function Header({ name, onPress, setToggle }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const { fetchRecentActivityNotifications, } = useNotification();
  const [profile, setProfile] = useState({});
  const [selected, setSelected] = useState();
  const [profileVisible, setProfileVisible] = useState(false);
  const [breadcrumb, setBreadcrumb] = useState(name?.split("/") ?? []);
  const { request } = useRequest();
  const [refresh, setRefresh] = useState(false);
  const { logout, setUserProfile } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleCreate = () => {
    form
      .validateFields()
      .then((values) => {
        onCreate(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const onCreate = (values) => {
    const { old_password, new_password } = values;
    const payload = {};
    if (!old_password || !new_password)
      return ShowToast("Please enter password ", Severty.ERROR);
    setLoading(true);
    payload.new_password = new_password;
    payload.old_password = old_password;
    request({
      url: apiPath.changePassword,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          setVisible(false);
          logout();
          form.resetFields();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    const splitName = name?.split("/");
    setBreadcrumb(splitName);
  }, [name]);

  useEffect(() => {
    request({
      url: apiPath.profile,
      method: "GET",
      onSuccess: (data) => {
        setProfile(data.data);
        setUserProfile(data.data);
        setSelected(data.data);
      },
    });

    fetchRecentActivityNotifications();
  }, [refresh]);

  return (
    <>
      <Row gutter={[24, 0]}>
        <Col
          span={12}
          md={12}
          xxl={12}
          xl={12}
          lg={12}
          className="header-left "
        >
          <div className="tab-logo">
            <img src={LogonewImg} alt="Logo" width={50} />
          </div>
          <div className="d-none d-lg-block desk-bar">
            <Button
              type="link"
              className="sidebar-toggler ps-0 d-none d-lg-block"
              onClick={() => setToggle()}
            >
              {toggler}
            </Button>
          </div>
          <h1
            style={{ fontWeight: "600", fontSize: "18px", textAlign: "center" }}
            className="main-center-logo-2"
          >
            Welcome
            <span style={{ textTransform: "capitalize" }}>
              {" - " + profile?.name}{" "}
            </span>
          </h1>
          <div className="breadcrumb-main d-none d-lg-block">
            <Breadcrumb>
              <Breadcrumb.Item>
                <NavLink to="/">Home</NavLink>
              </Breadcrumb.Item>

              {breadcrumb.map((item, index) => (
                <Breadcrumb.Item
                  key={item}
                  style={{ textTransform: "capitalize" }}
                >
                  {/* <NavLink to="/">{item}</NavLink> */}
                  {item}
                </Breadcrumb.Item>
              ))}
            </Breadcrumb>
          </div>
        </Col>

        <Col
          span={12}
          md={12}
          xl={12}
          xxl={12}
          lg={12}
          className="header-control"
        >
          <Button
            type="link"
            className="sidebar-toggler ps-0 d-lg-none"
            onClick={() => onPress()}
          >
            {toggler}
          </Button>
          <div className="profileDropdownMain">
            {/* <Dropdown menu={menuProps}> */}
            <Button
              className="ant-btn ant-btn-default ant-dropdown-trigger ant-dropdown-open"
              onClick={() => navigate("/profile")}
            >
              <div className="userName">
                {profile ? profile.name : "Administrator"}
              </div>
              <div className="userEmail">
                {profile ? profile.email : "admin@subscart.com"}{" "}
              </div>
            </Button>
            {/* </Dropdown> */}
            <Image
              src={
                profile && profile.profilePic ? profile.profilePic : defaultLogo
              }
              preview={false}
              onClick={() => navigate("/profile")}
              style={{ cursor: "pointer" }}
            />
          </div>

        </Col>
      </Row>

      {profileVisible && (
        <EditProfile
          show={profileVisible}
          hide={() => {
            setProfileVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      <Modal
        open={visible}
        title={`${lang("Change")} ${lang("Password")}`}
        okText={`${lang("Update")}`}
        cancelText={`${lang("Cancel")}`}
        onCancel={() => {
          setVisible(false);
          form.resetFields();
        }}
        okButtonProps={{
          form: "create",
          htmlType: "submit",
          loading: loading,
        }}
        onOk={handleCreate}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Old Password"
            name="old_password"
            hasFeedback
            rules={[
              { required: true, message: "Please enter the old password!" },
            ]}
          >
            <Input.Password placeholder="Enter your old password" />
          </Form.Item>
          <Form.Item
            label="New Password"
            name="new_password"
            dependencies={["old_password"]}
            hasFeedback
            rules={[
              { required: true, message: "Please enter the new password!" },
              { min: 6, message: "Please enter the atleast 6 charcaters!" },

              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("old_password") === value) {
                    return Promise.reject(
                      new Error(
                        "Old password & new password must be different!",
                      ),
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input.Password placeholder="Enter your new password" />
          </Form.Item>
          <Form.Item
            label="Confirm New Password"
            name="confirm_new_password"
            dependencies={["new_password"]}
            hasFeedback
            rules={[
              { required: true, message: "Please enter the confirm password!" },
              { min: 6, message: "Please enter the atleast 6 charcaters!" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("new_password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Confirm password & password does not match!"),
                  );
                },
              }),
            ]}
          >
            <Input.Password placeholder="Enter your confirm password" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

const EditProfile = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);
  const [image, setImage] = useState([]);
  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/avif",
    "image/webp",
    "image/gif",
  ];

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ ...data });
    setFile([data.image]);
  }, [data]);

  const handleImage = (data) => {
    setImage(data);
    data.length > 0 ? setFile(data[0].url) : setFile([]);
  };

  const onEditProfile = (values) => {
    const { email, name } = values;
    const payload = {};
    setLoading(true);
    payload.email = email;
    payload.name = name;
    payload.image = image && image.length > 0 ? image[0].url : "";

    request({
      url: apiPath.updateProfile,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      open={show}
      title={`Update Profile`}
      okText={`Update`}
      cancelText={`Cancel`}
      width={750}
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onEditProfile} layout="vertical">
        <Row>
          <Col span={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                { required: true, message: "Please enter the name!" },
                {
                  pattern: new RegExp(/^[a-zA-Z ]*$/),
                  message: "Only Alphabetic Characters Allowed",
                },
              ]}
            >
              <Input placeholder="Enter Name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Email Address"
              name="email"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
                { required: true, message: "Please enter the email!" },
              ]}
            >
              <Input placeholder="Enter Email Address" disabled />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              className="mb-0"
              rules={[
                {
                  validator: (_, value) => {
                    if (value !== undefined && value?.length > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Image is required"));
                  },
                },
              ]}
              label={"Upload Profile"}
              name="image"
            >
              <SingleImageUpload
                value={image}
                fileType={FileType}
                imageType={"user"}
                btnName={"Profile"}
                onChange={(data) => handleImage(data)}
              />
            </Form.Item>

            {file && file.length > 0 && (
              <div className="mt-2">
                {" "}
                <Image
                  width={120}
                  src={file !== "" ? file : notfound}
                ></Image>{" "}
              </div>
            )}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default Header;
